import { render, staticRenderFns } from "./ColReqAddressForm.vue?vue&type=template&id=211683f2&"
import script from "./ColReqAddressForm.vue?vue&type=script&lang=ts&"
export * from "./ColReqAddressForm.vue?vue&type=script&lang=ts&"
import style0 from "./ColReqAddressForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports